import {AdjuntoActionTypes, AdjuntosActions} from './adjuntos.actions';
import {adjuntosAdapter, AdjuntosState, initialState} from './adjuntos.state';

export function adjuntosReducer(state = initialState, action: AdjuntosActions): AdjuntosState {
  switch (action.type) {
    // load
    case AdjuntoActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case AdjuntoActionTypes.LOAD_SUCCESS: {
      return adjuntosAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case AdjuntoActionTypes.LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // add
    case AdjuntoActionTypes.ADD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case AdjuntoActionTypes.ADD_SUCCESS: {
      return adjuntosAdapter.addOne(action.payload.item, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case AdjuntoActionTypes.ADD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // add many
    case AdjuntoActionTypes.ADD_MANY_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case AdjuntoActionTypes.ADD_MANY_SUCCESS: {
      return adjuntosAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case AdjuntoActionTypes.ADD_MANY_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // add with callback
    case AdjuntoActionTypes.ADD_REQUEST_WITH_CALLBACK: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    // add many with callback
    case AdjuntoActionTypes.ADD_MANY_REQUEST_WITH_CALLBACK: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    // delete
    case AdjuntoActionTypes.DELETE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case AdjuntoActionTypes.DELETE_SUCCESS: {

      return adjuntosAdapter.removeOne(`${action.payload.item.adjuntoId}`, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case AdjuntoActionTypes.DELETE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
